export default "__VITE_PUBLIC_ASSET__196418cb__"